import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Mainnav/sgds-mainnav-dropdown";
import { register } from "../../utils/ce-registry";

register("sgds-mainnav-dropdown", Component);

export default createComponent({
  react: React,
  tagName: "sgds-mainnav-dropdown",
  elementClass: Component,
  events: {}
});
